import { ModifierDialogController } from './controllers/modifierDialogController';

import { ModifierGroupsDirective } from './directives/modifierGroupsDirective';

import { OptionPriceFilter } from './filters/optionPriceFilter';

import { CurrentItemService } from './services/currentItemService';
import { ItemDetailsService } from './services/itemDetailsService';
import { ModifierHierarchyHelper } from './services/modifierHierarchyHelper';

export const ModifiersModule = angular
    .module('oo.order.modifiers', [])
    .controller('ModifierDialogController', ModifierDialogController)
    .directive('ooModifierGroups', ModifierGroupsDirective)
    .filter('optionPrice', OptionPriceFilter)
    .service('currentItemService', CurrentItemService)
    .service('itemDetailsService', ItemDetailsService)
    .service('modifierHierarchyHelper', ModifierHierarchyHelper)
    .name;
